import React from "react";

const SEZFormSubmitSuccess = () => {
  return (
    <div className="final-message text-center">
      <h3 className="p-3 mb-2 bg-light text-dark">
        Thank you for submitting your details, Facilities team will further communicate on this.
      </h3>
    </div>
  );
}

export default SEZFormSubmitSuccess;